var readMoreToggle = document.querySelector('.read-more-toggle');
var readMoreContent = document.querySelector('.read-more');
var firstDesc = document.querySelector('.first-desc-part')

readMoreToggle?.addEventListener('click', function() {
  readMoreContent.classList.toggle('visible');
  firstDesc.classList.toggle('shown')
  
  if (readMoreToggle.textContent === 'Read More') {
    readMoreToggle.textContent = 'Read Less';
  } else {
    readMoreToggle.textContent = 'Read More';
  }
});